/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const salonSlider = () => {
		const splide = new Splide('.about-salon-slider.splide', {
			type: 'loop',
			perPage: 1,
			perMove: 1,
			autoplay: true,
			center: true,
			focus: 'center',
			interval: 5000,
			speed: 500,
			arrows: true,
			pagination: true,
			paginationKeyboard: true,
			focus: 'center',
			breakpoints: {
				1024: {

				},
			},
		}).mount();
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const aboutFUNCTIONS = () => {
		salonSlider();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { aboutFUNCTIONS(); }) : aboutFUNCTIONS();

})(window.FUNCTIONS);
